/**
 * Indicate that we changed of tab in the tab bar.
 * @type {string}
 */
export const CHANGE_ACTUAL_TAB = 'CHANGE_ACTUAL_TAB'
